import React, { useEffect, useState } from "react";
import "../../AdminScreens/AllEmployees/AllEmployees.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { MdSearch } from "react-icons/md";
import { FaPlus } from "react-icons/fa6";
import { GrRefresh } from "react-icons/gr";
import { FaEdit } from "react-icons/fa";
import { RiDeleteBinLine } from "react-icons/ri";
import { Modal } from "react-bootstrap";
import { RiEyeCloseFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import NewEmployeesModal from "../../../Components/Modals/NewEmployeesModal";
import { Apiurl, GetToken } from "../../../Utils/utils";
import Loader from "../../../Components/loader/loader";
import { CgProfile } from "react-icons/cg";
import dummyimage from "../../../Assets/Images/dummyimg.png";
import Button from 'react-bootstrap/Button';

const AllEmployees = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [allEmployeeData, setAllEmployeeData] = useState([]);
console.log(allEmployeeData,"allEmployeeDataallEmployeeData");
  const [showDeleteModal, setshowDeleteModal] = useState(false);
  const [leaveRequestDuplicate, setLeaveRequestDuplicate] = useState([]);

  const handleClose = () => setshowDeleteModal(false);
  const handleShow = () => setshowDeleteModal(true);

  const PlusHandler = () => {
    navigate("/Adm/Employees/AddEmployee");
  };
  const GetAllEmployee = () => {
    setLoading(true);
    const token = GetToken();
    const option = {
      method: "GET",  
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: `${Apiurl()}/Admin/GetAllEmployees`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setAllEmployeeData(data);
        setLeaveRequestDuplicate(data)
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    GetAllEmployee();
  }, []);
  const DeleteHandler = (event) => {
    const LoginToken = GetToken();
    const data = {};
    data.Id = DeletedItem?.Id;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/DeleteEmployee`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          GetAllEmployee();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  const handleEyeGetEmployee =(item)=>{
    navigate("/Adm/Employees/EmployeeProfile", { state: item });
  }
  // const handleEyeGetEmployee = (event) => {
  //   const LoginToken = GetToken();
  //   const data = {};  
  //   data.id = event?.Id;
  //   const option = {
  //     method: "POST",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "content-type": "application/json",
  //       authorization: `Bearer ${LoginToken}`,
  //     },
  //     url: `${Apiurl()}/Admin/GetEmployee`,
  //     data: { data: JSON.stringify(data) },
  //   };
  //   axios(option)
  //     .then((e) => {
  //       const data = JSON.parse(e?.data?.data);
  //       if (e?.status === 200) {
  //         toast.success(e?.data?.message);
  //         GetAllEmployee();
  //       }
  //       navigate("/Adm/Employees/EmployeeProfile", { state: data });
  //     })
  //     .catch((err) => {
  //       toast.error(err?.response?.data?.message);
  //     });
  // };
  const EditHandler = (e) => {
    navigate("/Adm/Employees/AddEmployee", { state: e });
  };
  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const [DeletedItem,setDeletedItem]=useState("")
  const handelDeleteModalOpen=(item)=>{
    setDeletedItem(item)
    setshowDeleteModal(true)
  }
  const handleDataSearch = (e) => {
    const searchTerm = e?.target?.value?.toLowerCase();
    if (searchTerm) {
      const filteredData = leaveRequestDuplicate?.filter((item) =>
        item?.FirstName?.toLowerCase()?.includes(searchTerm)
      );
      setAllEmployeeData(filteredData);
    } else {
      setAllEmployeeData(leaveRequestDuplicate);
    }
  };
  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <>
          <div
            className={
              showSidebar
                ? "main-container-of-all-employees-page"
                : "main-container-of-all-employees-page-new"
            }
          >
            <div className="inner-container-of-all-employees-page ">
              <div className="header-of-employees-page row">
                <div className="all-employee-text col">
                  <h4>All Employee</h4>
                </div>
                <div className="all-employees-directory col">
                  <div className="home-icon-header">
                    <BiHomeAlt className="home-icon-header-inn" />
                  </div>
                  <div className="arrow-icon-header">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="employee-text-header">
                    <p>Employees</p>
                  </div>
                  <div className="arrow-icon-header">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="all-employee-text-header">
                    <p>All Employee</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="body-part-outer-container">
              <div className="inner-body-container-of-employee-table row-12">
                <div className=" all-employees-first-side-in-body-header col-6">
                  <div className="allemployee-text-in-body">
                    <h2>Employees</h2>
                  </div>
                  <div className="all-employee-input-for-search-in-employee-body">
                    <MdSearch className="search-icon-in-input" />
                    <input type="text" placeholder="Search" onChange={(e) => handleDataSearch(e)} />
                  </div>
                </div>
                <div className=" images-section-on-body col-6 ">
                  <div className="plus-button-in-body">
                    <button onClick={() => PlusHandler()}>
                      <FaPlus className="plusbutton-icon" />
                    </button>
                  </div>
                  <div className="reloard-button-in-body">
                    <button>
                      <GrRefresh className="refreshbutton-icon" />
                    </button>
                  </div>
                </div>
              </div>
              <div className="table-in-all-emplyee-body">
                <table className="table-main-class">
                  <thead className="thead-main-class">
                    <tr className="row-12">
                      <th>Sr.no </th>
                      <th className="col-1">Image</th>
                      <th className="col-1">Name</th>
                      <th className="col-2">Email</th>
                      <th className="col-3">Department</th>
                      <th className="col-3">Designation</th>
                      <th className="col-1">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="tbody-main-class">
                    {allEmployeeData?.length ? (
                      <>
                        {allEmployeeData?.map((item, index) => {
                          return (
                            <tr key={index} className="tr-all-employee-tbl">
                              <td>{index + 1}</td>
                              <td>
                                    {item?.UrlLink ? (
                                      item?.UrlLink && (
                                        <img
                                          className="image-of-header"
                                          src={item.UrlLink}
                                          onError={(e)=>e.target.src=dummyimage}
                                          alt="Profile Image"
                                        />
                                      )
                                    ) : (
                                      <img src={dummyimage} className="profile-icon-header"/>
                                    )}
                                  </td>
                              <td>
                                {item?.FirstName ? item?.FirstName : "---"}
                              </td>
                              <td>{item?.Email ? item?.Email : "---"}</td>
                              <td>
                                {item?.Departments?.Name
                                  ? item?.Departments?.Name
                                  : "---"}
                              </td>
                              <td>
                                {item?.Designations?.DesignationName
                                  ? item?.Designations?.DesignationName
                                  : "---"}
                              </td>
                              <td className="edit-icon-in-td">
                                <FaEdit
                                  className="edit-icon-main"
                                  onClick={() => EditHandler(item)}
                                />
                                <RiDeleteBinLine
                                  className="delete-icon-main"
                                  // onClick={()=>DeleteHandler(item)}
                                  onClick={() => handelDeleteModalOpen(item)}
                                />
                                <RiEyeCloseFill
                                  className="eye-icon-main"
                                  onClick={() => handleEyeGetEmployee(item)}
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    ) : (
                      <>
                        <tr className="no-record-found-tr-dashboard">
                          <td colSpan="10">No record found</td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      </div>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        className="modal-in-employee-table"
      >
        <NewEmployeesModal className="modal-main-inner-container" />
      </Modal>
{/* allEmp Delete modal  */}
      <Modal show={showDeleteModal} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Confirmation </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="Flex-container-of-allEMp-modal">

         <div>

  <p> <span className="AllEMP-Modal-headings">First Name:</span>  {DeletedItem.FirstName}</p>
  <p> <span  className="AllEMP-Modal-headings">Last Name:</span> {DeletedItem.LastName}</p>
  <p><span  className="AllEMP-Modal-headings"> Mobile:</span> {DeletedItem.Mobile} </p>
  </div>

  <p>  {DeletedItem?.UrlLink ? (
                                      DeletedItem?.UrlLink && (
                                        <img
                                          className="image-of-delete-modal"
                                          src={DeletedItem.UrlLink}
                                          onError={(e)=>e.target.src=dummyimage}
                                          alt="Profile Image"
                                        />
                                      )
                                    ) : (
                                      <img src={dummyimage} className="profile-icon-header"/>
                                    )}</p>
                                     </div>
          
        </Modal.Body>
        <Modal.Footer>
          <Button className="Close-Button-forAllEmp" variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button className="Delete-modal-forAllEmp" variant="primary" onClick={DeleteHandler}>
           Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default AllEmployees;
